export default "__VITE_ASSET__CJldg18j__"